import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import styled from "styled-components";
import notionServices from "@/services/notion";
import { NotionRenderer } from "react-notion";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import slugify from "slugify";
import { useRouter } from "next/router";

const Wrapper = styled.div`
  ul {
    margin-left: 32px;
  }
`;

export async function getServerSideProps({ locale }) {
  const pageId =
    locale === "en"
      ? process.env.NEXT_PUBLIC_PRIVACY_PAGE_ID_EN
      : process.env.NEXT_PUBLIC_PRIVACY_PAGE_ID_VI;

  const response = await notionServices.fetchNotionPage(pageId);
  return {
    props: {
      notionContent: response,
      ...(await serverSideTranslations(locale)),
    },
  };
}
export default function TermsAndSecurity({ notionContent }) {
  const { t } = useTranslation("privacy");
  const [sidebar, setSidebar] = useState([]);
  useEffect(() => {
    const headings = document.querySelectorAll(".notion-h2");
    let listSidebar = [];
    headings.forEach((element) => {
      listSidebar.push({
        title: element.textContent,
        id: slugify(element.textContent).split(".-").slice(-1),
      });
      element.setAttribute(
        "id",
        slugify(element.textContent).split(".-").slice(-1)
      );
    });
    setSidebar(listSidebar);
  }, []);

  const jumbToBlock = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView(
      {
        behavior: "smooth",
      },
      true
    );
  };
  return (
    <>
      <Head>
        <title>{t("seo.title")}</title>
        <meta name="title" content={t("seo.title")} />
        <meta name="description" content={t("seo.desc")} />

        <meta property="og:title" content={t("seo.title")} />
        <meta property="og:description" content={t("seo.desc")} />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_SITE_URL}${
            useRouter().locale === "vi" ? "/vi" : ""
          }${useRouter().asPath}`}
        />
        <meta
          property="og:image"
          content={`${process.env.NEXT_PUBLIC_SITE_URL}/ThumbnailCyStack.png`}
        />

        <meta name="twitter:title" content={t("seo.title")} />
        <meta name="twitter:description" content={t("seo.desc")} />
        <meta
          name="twitter:image"
          content={`${process.env.NEXT_PUBLIC_SITE_URL}/ThumbnailCyStack.png`}
        />
      </Head>

      <div className="container py-[100px]">
        <div className="flex gap-[102px]">
          <div className="sidebar w-max max-w-[320px] lg:hidden">
            <ul className="p-0 m-0 list-none sticky top-20">
              {sidebar.map((item, index) => (
                <li
                  key={index}
                  className="text-body2sb text-dark-grey mb-2 last:mb-0 cursor-pointer hover:text-dark"
                  onClick={() => jumbToBlock(item.id)}
                >
                  {item.title}
                </li>
              ))}
            </ul>
          </div>
          <Wrapper className="flex-1 posts-detail__content">
            <NotionRenderer blockMap={notionContent} />
          </Wrapper>
        </div>
      </div>
    </>
  );
}
